import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["purchaseMotion", "apiName", "trackingSource", "screen", "termOverride", "use", "sourceId", "skipInterstitialPage"];
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import CodeSplitEnvWrapper from '../../../components/common/env/CodeSplitEnvWrapper';
import { APP } from '../../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../../reducers';
import { productsFromProductInventoryQuantitySelector } from '../../../selectors/ProductInventorySelectors';
import { currentSkuIdForProductSelector, upgradeProductSelector } from '../../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import LoadingCTA from './LoadingCTA';
import { jsx as _jsx } from "react/jsx-runtime";
const SingleProductCTA = _ref => {
  let {
      purchaseMotion,
      apiName,
      trackingSource,
      screen,
      termOverride,
      use = 'primary',
      sourceId = trackingSource,
      skipInterstitialPage = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const skuId = useAppSelector(state => {
    return currentSkuIdForProductSelector(state, {
      apiName
    });
  });
  const ownedQuantity = useAppSelector(state => {
    if (!skuId) return 0;
    return productsFromProductInventoryQuantitySelector(state, {
      skuId
    });
  });
  const quantityToPurchase = skipInterstitialPage ? ownedQuantity + 1 : undefined;
  const productConfigurations = skuId ? [createProductConfig({
    skuId,
    quantity: quantityToPurchase
  })] : [];
  const upgradeProduct = useAppSelector(state => upgradeProductSelector(state, {
    skuIds: productConfigurations.map(config => config.skuId)
  }));
  const {
    queryParamTerm
  } = useQueryParamTerm();
  if (!skuId) {
    return null;
  }
  const upgradeData = {
    app: APP,
    screen,
    uniqueId: `${trackingSource}-${apiName}`,
    upgradeProduct,
    apiName
  };
  const sharedProps = Object.assign({
    productConfigurations,
    queryParamTerm: termOverride !== null && termOverride !== void 0 ? termOverride : queryParamTerm,
    trackingSource,
    purchaseMotion,
    use
  }, rest);
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import( /* webpackChunkName: "authed-chunk" */`pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper`),
    publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/features/purchaseMotions/components/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, sharedProps, {
      upgradeData,
      trackingSource,
      nonMerchandiseIdIdentifier: apiName,
      skipInterstitialPage
    }),
    publicComponentProps: Object.assign({}, sharedProps, {
      dtbSource: `pricing-page|${trackingSource}`,
      sourceId,
      nonMerchandiseIdProduct: apiName
    }),
    authedComponentLoadingState: LoadingCTA,
    publicComponentLoadingState: LoadingCTA
  });
};
export default SingleProductCTA;